<template>
	<p>{{ pageContent }}</p>
</template>

<script lang="ts" setup>
// ====---------------====
// 🚀 Imports
// ====---------------====
import { useSelectedPlanStore } from '@/stores/plans/selectedPlan.ts'
import { getPageContent } from '@/services/cms/utils.ts'
import { onMounted, ref } from 'vue'

// ====---------------====
// 🏪 Stores
// ====---------------====
const lobAbbr = ref<string>('ABCBS')
const pageContent = ref<GenericContent>('')

// ====---------------====
// 🌄 Lifecycle
// ====---------------====
onMounted(() => {
	lobAbbr.value = useSelectedPlanStore().getStore().tier1 ?? 'ABCBS'
	pageContent.value =
		getPageContent(`LinkingDisclaimer${lobAbbr.value}`) ??
		(getPageContent(`LinkingDisclaimerABCBS`) as string)
})
</script>
